import styles from './AdvantageList.module.scss';

type AdvantageListType = {
	items: string[];
};

export default function AdvantageList(props: AdvantageListType) {
	const { items } = props;
	return (
		<div className={styles.wrap}>
			<ul className={styles.list}>
				{items.map((item, index) => (
					<li key={index} className={styles.item}>
						{item}
					</li>
				))}
			</ul>
		</div>
	);
}
